import { Card } from "@emanprague/ppaskit";
import React from "react";
import DOMPurify from "dompurify";
import { observer } from "mobx-react-lite";
import styles from "./style.module.scss";
import { parseDisabledLoginContent } from "helpers/disabledLoginContentHelper";

interface DisabledLoginReasonProps {
  content: string;
}

/*
Component to display a "maintenance notice" when the user is not allowed to log in
Content is customizable in admin page
*/
const DisabledLoginReason: React.FunctionComponent<DisabledLoginReasonProps> = observer(({ content }) => {
  const { title, paragraphs } = parseDisabledLoginContent(content);
  return (
    <Card className="border-right-sm z-index-1">
      <Card.Body className={styles.cardBody}>
        <h1 className="display-1 text-center">{title}</h1>
        {paragraphs.map((paragraph, index) => (
          <p
            key={index}
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(paragraph),
            }}
          />
        ))}
      </Card.Body>
    </Card>
  );
});

export default DisabledLoginReason;
